import React, {Component} from 'react';
import '../styles/Home.css'
import {Link} from "react-router-dom";
import Footer from "../shared/Footer";
import LoginService from "../admin/loginComponents/LoginService";

export default class Aktywacja extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aktywacja: true,
            loading: true
        }
    }

    componentDidMount() {
        LoginService.aktywujKonto(this.props.match.params.token)
            .then(function (response) {
                if (response.status === 200) {
                    this.setState({aktywacja: true, loading: false})
                } else {
                    this.setState({aktywacja: false, loading: false})
                }
            }.bind(this))
            .catch(error => {
                console.log(error);
                this.setState({aktywacja: false, loading: false})
            })
    }

    render() {
        return <div>
            <div className="wynajemNaglowek przerywnik">
                <div className="container text-center">
                    <h2><b>Załóż konto by uzyskać nowe możliwości!</b></h2>
                    <h4>Dzięki rejestracji uzyskasz dostęp do danych o swoich biletach, oraz informacje o kursach
                        eventowych.</h4>
                </div>
            </div>
            <div style={{background: '#efefef'}}>
                <div className="container" style={{padding: 15}}>
                    {this.state.loading ? <div>
                        <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                            className="fa fa-spinner fa-pulse fa-2x fa-fw"
                            style={{
                                color: '#58b13d'
                            }}> </i></div>
                    </div> : <div>
                        {this.state.aktywacja ?
                            <div className="text-center ramka" style={{padding: 100, background: 'white'}}>
                                <b><h2><i className="fa fa-2x fa-check" style={{color: '#8dc846'}}> </i> Aktywacja konta
                                    przebiegła pomyślnie</h2>
                                    <h5 style={{fontWeight: 400}}><Link to={"/login"}>Zaloguj się</Link> by uzupełnić
                                        dane osobowe i
                                        korzystać z konta.</h5></b>
                            </div> :
                            <div className="text-center ramka" style={{padding: 100, background: 'white'}}>
                                <b><h2><i className="fa fa-2x fa-times" style={{color: '#c82825'}}> </i> Aktywacja konta
                                    się nie powiodła.</h2>
                                    <h5 style={{fontWeight: 400}}>Spróbuj ponownie lub skontaktuj się z BOK.</h5></b>
                            </div>}</div>}
                </div>
            </div>
            <Footer/>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/Aktywacja.js